<template lang="pug">
div.file-upload
  input.form-control(type="file", @change="uploadFile")
  div.form-help-block(v-if="currentFile")
    span Current file: #[strong(v-text="currentFile.name")]
    a.small.ml-1(@click="clearFile") #[icon(icon="times")] Clear
</template>

<script>
import {has,get,isEmpty,startCase} from 'lodash-es'

export default {
  name: 'FileUpload',
  props: ['value', 'type'],
  data: () => ({
    currentFile: {}
  }),
  watch: {
    value: {
      immediate: true,
      handler: function() {
        this.currentFile = this.value
      }
    }
  },
  methods: {
    uploadProgress(progress) {
      console.log('progress', progress)
    },
    uploadFile(event) {
      var file = get(event, 'target.files.0', false)
      this.clearFile()
      if (!file)
      {
        return
      }

      let formData = new FormData()
      formData.append('file', event.target.files[0])
      formData.append('file', this.type)

      var headers = {'Content-Type': 'multipart/form-data'}
      this.$http.post( '/files', formData, {headers, onUploadProgress: this.uploadProgress})
        .then((response) => this.changeValue(get(response, 'data.item')))
        .catch((error) => console.log('FAILURE!!', error))
    },
    changeValue(value) {
      this.$emit('input', value)
    },
    clearFile() {
      this.changeValue(null)
    }
  }
}
</script>

<style lang="scss">
</style>